// SEQ-217: the "Create in Dashpivot" button on the Variations and Install &
// Hire sub-tabs. Always enabled and always points at the shared Contract
// Variance app, whatever the project's Foreman app id is (or whether it has
// one). Written with createElement, not JSX, so the deno tests can render it
// with the react and react-dom the app already depends on.

import { createElement, type ReactElement } from "react";
import { Plus } from "lucide-react";
import { dashpivotCreateVariationUrl } from "../lib/dashpivotLinks.ts";

export function CreateInDashpivotLink(): ReactElement {
  return createElement(
    "a",
    {
      href: dashpivotCreateVariationUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "btn btn-primary",
      title: "Opens the Contract Variance app. Choose the job in the List field.",
      style: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        textDecoration: "none",
      },
    },
    createElement(Plus, { size: 16 }),
    "Create in Dashpivot",
    createElement(
      "span",
      { className: "pnl-visually-hidden" },
      " (opens Contract Variance in a new tab)",
    ),
  );
}
